import { matchPath } from "react-router";
import { CLIENTS_ROUTES } from "../../../../consts/routes";

export const getPathParams = () => {
  const { params } = matchPath(window.location.pathname, {
    path: CLIENTS_ROUTES.newDocuments(":patientId"),
    exact: true,
    strict: false,
  });

  return {
    patientId: params.patientId ? Number(params.patientId) : undefined,
  };
};

export const isMedicalHistoryFile = (name) => {
  return name?.toLowerCase().includes("medical_history");
};

export const isFileManagementAllowed = (name, permissions = []) => {
  if (isMedicalHistoryFile(name)) {
    return permissions.includes("manage-medical-history");
  }

  return true;
};

export const isDocumentSelectable = (
  document,
  { canMutate, canView, permissions = [] },
) => {
  return (
    (canMutate || canView) &&
    isFileManagementAllowed(document.name, permissions) &&
    !document.isLock &&
    document.canEdit
  );
};

export const filterSelectableDocumentIds = (
  selected,
  selectableDocumentIds,
) => {
  const selectableIds = new Set(selectableDocumentIds);
  return selected.filter((id) => selectableIds.has(id));
};
